// libs
import { combineReducers } from 'redux';
import { i18nState } from 'redux-i18n';

// reducers
import { reducer as formReducer } from 'redux-form';
import activityReducer from './activity';
import artworkReducer from './artwork';
import footerReducer from './footer';
import navReducer from './nav';
import homeReducer from './home';
import landingReducer from './landing';
import modalReducer from './modal';
import newsletterReducer from './newsletter';
import notFoundReducer from './notFound';
import pageReducer from './page';
import pagesReducer from './pages';
import promisesReducer from './promises';
import searchReducer from './search';
import userReducer from './user';
import lexiqueReducer from './lexique';

const rootReducer = combineReducers({
  i18nState,
  activity: activityReducer,
  artwork: artworkReducer,
  footer: footerReducer,
  form: formReducer,
  home: homeReducer,
  landing: landingReducer,
  modal: modalReducer,
  nav: navReducer,
  newsletter: newsletterReducer,
  notFound: notFoundReducer,
  page: pageReducer,
  pages: pagesReducer,
  promises: promisesReducer,
  search: searchReducer,
  user: userReducer,
  lexique: lexiqueReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/app/reducers/index.js